export enum AccountStatusEnum {
  INITIAL = 'INITIAL',
  PROVISIONAL = 'PROVISIONAL',
  ACTIVE = 'ACTIVE',
  FULLY_IDENTIFIED = 'FULLY_IDENTIFIED',
  BLOCKED_FULL = 'BLOCKED_FULL',
  BLOCKED_PARTIAL = 'BLOCKED_PARTIAL',
  CLOSED_PROVISIONAL = 'CLOSED_PROVISIONAL',
  CLOSED_ACTIVE = 'CLOSED_ACTIVE',
  INACTIVE = 'INACTIVE',
}
